module.exports = __webpack_public_path__ + "assets/img/19-s.9c19f50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/19-s.jpg
// module id = MqRX
// module chunks = 0